<template>
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">
    <van-nav-bar
      title="问题检查记录"
      left-text="返回"
      left-arrow
      @click-left="$router.back()"
      id="topbar"
    />
    <div style="padding:20px">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
      >
        <div  class="record" v-for="(item,index) in problemCheckTaskList" :key="index">
          <div style="padding:0px 20px;border-bottom:1px solid #EBEEF5;">
            <div class="typeTxt">
              <p>{{item.submitDate | conversion}}</p>
              <br>
              <span>未处理问题数量： {{item.count}}</span>
              <van-button style="float: right;margin-top: -35px;border-radius: 10px;"
                          type="danger" @click="remove(item.id)" size="mini">删除
              </van-button>
              <van-button style="float: right;margin-top: -35px;border-radius: 10px;margin-right: 60px"
                          type="info" @click="detailProblem(index)" size="mini">详情
              </van-button>

            </div>

          </div>
        </div>

      </van-list>
    </div>

  </div>
</template>
<script>
import $ from '@/fly'
import Setting from '@/setting';
import Vue from 'vue';
import {ImagePreview, Toast, Dialog} from 'vant';

Vue.use(ImagePreview);
export default {
  name: 'probleCheckTask',
  data() {
    return {
      clientHeight: window.screen.height,
      problemCheckTaskList: [],
      loading: false,
      finished: false,
      apiUrl: Setting.apiBaseURL
    }
  },
  computed: {},
  methods: {
    remove(id){
      Dialog.confirm({
        title: '确认提示',
        message: '确认要删除当前数据',
      })
        .then(() => {
          // on confirm
          $.delete('problemCheckTask/'+id).then(res=>{

            Toast.success("删除成功")
            this.getProblemCheckTask()
          })
        })
        .catch(() => {
          // on cancel
        });

    },
    detailProblem(index){
      localStorage.setItem('checkTaskProblemList',JSON.stringify(this.problemCheckTaskList[index].problemList))
      this.$router.push({ name: 'project-problemFollowCheckTask' });
    },
    getProblemCheckTask() {
      let companyId = localStorage.getItem('companyId')
      let projectId = localStorage.getItem('projectId')
      let userId = JSON.parse(localStorage.getItem('USER')).userId
      $.get('problemCheckTask/getCheckTask', {
        'userId': userId,
        'companyId': companyId,
        'projectId': projectId
      }).then(res => {
        console.log('res', res)
        this.loading = false;
        this.finished = true;
        this.problemCheckTaskList = res
      })
    }
  },
  filters: {
    conversion: function (value) {
      //调用Date的方法，处理时间戳
      return new Date(value).toLocaleString();
    },
  },
  mounted() {
    this.getProblemCheckTask()
  }
}

</script>

<style lang="less" scoped>
.record {
  background-color: #FFFFFF;
  margin-bottom: 20px;
}

.typeTxt {
  font-size: 30px;
  font-weight: bold;
  border-bottom: 1px solid #EBEEF5;
  padding: 25px 0px 15px 0px;
  letter-spacing: 1px;
}

.typeTxt span {
  width: 5px;
  //background-color:#50C9FF;
  //display:inline-block;
  height: 34px;
  vertical-align: middle;
}

.infoRow {
  padding: 20px 5px;
  font-size: 26px;
  font-weight: bold;
}

.infoRow .van-col:nth-child(1) {
  color: #999999;
}

.picture {
  width: 30%;
}
</style>
